import axios from 'axios';
let _publicKey;
export function setPublicKey(key) {
    _publicKey = key;
}
// Add a request interceptor to include X-Public-Key header.
// Optional-chain the registration so importing this module doesn't throw when
// `axios` is replaced by a minimal test mock lacking `.interceptors`. The real
// axios always has it, so production behavior is unchanged.
axios.interceptors?.request?.use(function (config) {
    if (_publicKey) {
        config.headers = config.headers ?? {};
        config.headers['X-Public-Key'] = _publicKey;
    }
    return config;
});
// Add a response interceptor
axios.interceptors?.response?.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    return Promise.reject(error);
});
export default axios;
